import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Container, Row, Col, Alert, Spinner } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/account.js';
import { AUTH_LOGIN_ENDPOINT } from '../../config/api';
import { useAuth } from '../../context/AuthContext';

const initialForm = {
  email: '',
  password: ''
};

const isValidEmail = (value) => /.+@.+\..+/.test(value);

function Login() {
  const history = useHistory();
  const [formValues, setFormValues] = useState(initialForm);
  const [fieldErrors, setFieldErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [formError, setFormError] = useState('');
  const { refreshUser } = useAuth();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
    setFieldErrors((prev) => ({ ...prev, [name]: '' }));
    setFormError('');
  };

  const validate = () => {
    const errors = {};
    if (!formValues.email.trim()) {
      errors.email = 'Email is required';
    } else if (!isValidEmail(formValues.email.trim())) {
      errors.email = 'Please enter a valid email address';
    }

    if (!formValues.password.trim()) {
      errors.password = 'Password is required';
    }

    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const persistAuth = ({ token, user }) => {
    if (token) {
      localStorage.setItem('authToken', token);
    }
    if (user) {
      localStorage.setItem('authUser', JSON.stringify(user));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validate()) {
      return;
    }

    setSubmitting(true);
    setFormError('');

    try {
      const response = await fetch(AUTH_LOGIN_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: formValues.email.trim(),
          password: formValues.password
        })
      });

      if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new Error(payload.message || 'Unable to sign in. Please try again.');
      }

      const payload = await response.json();
      persistAuth(payload);
      if (typeof refreshUser === 'function') {
          await refreshUser();
      }
      history.push(`${process.env.PUBLIC_URL || ''}/courses`);
    } catch (error) {
      console.error(error);
      setFormError(error.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Styles>
      <div className="main-wrapper login-page">
        <HeaderTwo />
        <BreadcrumbBox title="Log In" />

        <section className="login-area">
          <Container>
            <Row>
              <Col md="12">
                <div className="login-box">
                  <div className="login-title text-center">
                    <h3>Log In</h3>
                  </div>
                  {formError && (
                    <Alert variant="danger">{formError}</Alert>
                  )}
                  <form className="form" onSubmit={handleSubmit} noValidate>
                    <p className={`form-control ${fieldErrors.email ? 'error' : ''}`}>
                      <label htmlFor="login_email">Email</label>
                      <input
                        type="email"
                        placeholder="name@example.com"
                        id="login_email"
                        name="email"
                        value={formValues.email}
                        onChange={handleChange}
                        disabled={submitting}
                      />
                      {fieldErrors.email && <span className="login_input-msg">{fieldErrors.email}</span>}
                    </p>
                    <p className={`form-control ${fieldErrors.password ? 'error' : ''}`}>
                      <label htmlFor="login_password">Password</label>
                      <input
                        type="password"
                        placeholder="*******"
                        id="login_password"
                        name="password"
                        value={formValues.password}
                        onChange={handleChange}
                        disabled={submitting}
                      />
                      {fieldErrors.password && <span className="login_input-msg">{fieldErrors.password}</span>}
                    </p>
                    <button type="submit" disabled={submitting}>
                      {submitting ? <Spinner animation="border" size="sm" /> : 'Log In'}
                    </button>
                    <div className="save-forget-password d-flex justify-content-between">
                      <div className="forget-password">
                        <Link to={process.env.PUBLIC_URL + '/registration'}>Create account</Link>
                      </div>
                      <div className="forget-password">
                        <Link to={process.env.PUBLIC_URL + '/forgot-password'}>Forgot password?</Link>
                      </div>
                    </div>
                    <div className="not_account-btn text-center">
                      <p>
                        Haven't any account yet?{' '}
                        <Link to={process.env.PUBLIC_URL + '/registration'}>Click Here</Link>
                      </p>
                    </div>
                  </form>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <FooterTwo />
      </div>
    </Styles>
  );
}

export default Login;
